import { GET_SELLER_PRODUCTS } from "../../apis/configuration";
import { useEffect, useState } from "react";
import { handleApi } from "../../apis";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

/**
 * Custom hook to get suppliers products
 * @returns products and loading state
 */

const useGetSellerProducts = (isSeller) => {
  const [stockList, setStockList] = useState({
    stockCount: 0,
    list: [],
  });
  const [loading, setLoading] = useState({
    productsLoad: true,
    pageLoad: false,
  });
  const navigate = useNavigate();
  useEffect(() => {
    if (isSeller) handleGetProducts();
  }, []);

  /**
   * Get all products from suppliers
   */

  const handleLoading = () =>
    setLoading({ productsLoad: false, pageLoad: false });

  const handleGetProducts = (offset = 0, limit = 15, params) => {
    if (offset > 0 || params?.offset > 0) setLoading({ ...loading, pageLoad: true });
    if (offset == 0 || params?.offset == 0 ) setLoading({ ...loading, productsLoad: true });

    return new Promise(async (resolve, reject) => {
      handleApi(
        GET_SELLER_PRODUCTS,
        params || { offset, limit },
        null,
        navigate,
      )
        .then((resp) => {
          const { count, results } = resp || {};

          setStockList({
            stockCount: count,
            list: offset > 0 || params?.offset > 0 ? [...stockList.list, ...results] : results,
          });

          handleLoading();
          resolve();
        })
        .catch((err) => {
          handleLoading();
          toast.error(err?.response?.data?.message || "Something went wrong", {
            className: "errorToast",
          });
          reject(err);
        });
    });
  };

  return {
    handleGetProducts,
    stockList,
    loading,
  };
};

export default useGetSellerProducts;
